export const DEVELOPER = {
  name: "Rudi Rusminarno",
  role: "Program Developer",
  org: "LPK Yutaka Education Center",
  division: "Yutaka Dx Division — AI Optimization & Development Section",
  address: "Ruko Dharmawangsa III, Perumahan Jl. Grand Taruma No.23 Blok E, Sukamakmur, Telukjambe Timur, Karawang, Jawa Barat 41361",
};

export function DeveloperCredit({ compact = false, testid = "developer-credit" }) {
  return (
    <div data-testid={testid} className={compact ? "text-xs text-muted-foreground" : "text-sm text-muted-foreground"}>
      <p><span className="font-semibold text-foreground">{DEVELOPER.role}: {DEVELOPER.name}</span></p>
      <p>{DEVELOPER.org} · {DEVELOPER.division}</p>
      {!compact && <p className="mt-1">{DEVELOPER.address}</p>}
    </div>
  );
}
